















































// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, ref, computed, watchEffect, Ref } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ElementChipNormValue from '@/components/elements/ElementChipNormValue.vue';
// Import plugins ----------------------------------------------------------------------------------
import { DrawSVG } from '@/plugins/charts/strike-pattern/single-strike-pattern-running-advanced';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartRunningStrikePatternAdvanced',
  components: {
    ElementChipNormValue
  },
  props: {
    aggregates: {
      type: Object,
      required: true
    }
  },
  setup(properties) {
    const rLeftCanvas: Ref<HTMLCanvasElement | null> = ref(null);
    const rRightCanvas: Ref<HTMLCanvasElement | null> = ref(null);
    const rLeftFootCanvas: Ref<HTMLCanvasElement | null> = ref(null);
    const rRightFootCanvas: Ref<HTMLCanvasElement | null> = ref(null);

    const angleTranslations: any = {
      rearfoot_strike: 'commons.standards.heel',
      midfoot_strike: 'commons.standards.midfoot',
      forefoot_strike: 'commons.standards.forefoot'
    };

    const strikePattern = computed(() => {
      return {
        left: {
          angle: properties.aggregates.running_plantar_flexion_angle_foot_in.left_foot.avg,
          impact: properties.aggregates.running_impact_force.left_foot.avg,
          angleType: properties.aggregates.running_strike_pattern.left_foot.avg
        },
        right: {
          angle: properties.aggregates.running_plantar_flexion_angle_foot_in.right_foot.avg,
          impact: properties.aggregates.running_impact_force.right_foot.avg,
          angleType: properties.aggregates.running_strike_pattern.right_foot.avg
        }
      };
    });

    function draw() {
      const shoesCanvas = {
        left: rLeftFootCanvas.value as HTMLCanvasElement,
        right: rRightFootCanvas.value as HTMLCanvasElement
      };
      if (rLeftCanvas.value && rRightCanvas.value) {
        const leftCanvas = new DrawSVG(
          rLeftCanvas.value as HTMLCanvasElement,
          strikePattern.value.left,
          'left',
          shoesCanvas.left
        );
        requestAnimationFrame(() => {
          leftCanvas!.draw();
        });
        const rightCanvas = new DrawSVG(
          rRightCanvas.value as HTMLCanvasElement,
          strikePattern.value.right,
          'right',
          shoesCanvas.right
        );
        requestAnimationFrame(() => {
          rightCanvas!.draw();
        });
      }
    }

    watchEffect(() => {
      draw();
    });

    return {
      rLeftCanvas,
      rRightCanvas,
      rLeftFootCanvas,
      rRightFootCanvas,
      angleTranslations,
      strikePattern
    };
  }
});
